import axios from 'axios';
import { useEffect } from 'react';
import { isCenterViewTab, shouldBlockCenterViewRequest } from '../lib/utils';

const useAxiosInterceptor = ({ createAlert, clearLocalStorage, navigate }: any) => {
    useEffect(() => {
        const isAuthFailure = (error: any) => {
            const status = error?.response?.status;
            const message = error?.response?.data?.message;

            return status === 401 || (status === 403 && message === 'not logged in');
        };

        // api 요청 전역감지
        const requestInterceptor = axios.interceptors.request.use(
            (config) => {
                if (shouldBlockCenterViewRequest(config.method, config.readOnlySafe)) {
                    createAlert('', '센터 열람 모드에서는 데이터를 변경할 수 없습니다.', true);
                    return Promise.reject({
                        isAxiosError: true,
                        viewOnlyHandled: true,
                        config,
                        response: {
                            status: 403,
                            data: { code: 'VIEW_ONLY', message: 'Center view sessions are read-only.' },
                            config,
                            headers: {},
                            statusText: 'Forbidden',
                        },
                    });
                }
                return config;
            },
            (error) => {
                if (error?.response?.data?.code === 'VIEW_ONLY') {
                    createAlert('', '센터 열람 모드에서는 데이터를 변경할 수 없습니다.', true);
                    return Promise.reject(error);
                }
                if (isAuthFailure(error)) {
                    createAlert('', '세션이 만료되었습니다');
                    clearLocalStorage();
                    navigate(isCenterViewTab() ? '/center-view' : '/signIn');
                }

                return Promise.reject(error);
            }
        );

        // api 응답 전역감지
        const responseInterceptor = axios.interceptors.response.use(
            (response) => {
                return response;
            },
            (error) => {
                if (error?.response?.data?.code === 'VIEW_ONLY' && !error?.viewOnlyHandled) {
                    createAlert('', '센터 열람 모드에서는 데이터를 변경할 수 없습니다.', true);
                }
                if (isAuthFailure(error)) {
                    createAlert('', '세션이 만료되었습니다');
                    clearLocalStorage();
                    navigate(isCenterViewTab() ? '/center-view' : '/signIn');
                }

                return Promise.reject(error);
            }
        );

        return () => {
            axios.interceptors.request.eject(requestInterceptor);
            axios.interceptors.response.eject(responseInterceptor);
        };
    }, []);
};

export default useAxiosInterceptor;
